import { createContext, useContext, useReducer, useMemo } from 'react';
import { ProsemirrorContextProvider } from 'foundations-components/transitional/context';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const initialState = {};
const PortalApiContext = /*#__PURE__*/createContext({
  createPortal: () => {},
  destroyPortal: () => {}
});
const PortalStateContext = /*#__PURE__*/createContext({});
const ReactNodeViewPortalsProvider = ({
  children
}) => {
  const [data, dispatch] = useReducer(reducer, initialState);
  const portalApi = useMemo(() => ({
    createPortal(portal) {
      dispatch({
        type: 'createPortal',
        key: portal.key,
        portal
      });
    },
    destroyPortal(key) {
      dispatch({
        type: 'destroyPortal',
        key
      });
    }
  }), []);
  return /*#__PURE__*/_jsx(ProsemirrorContextProvider, {
    children: /*#__PURE__*/_jsx(PortalApiContext.Provider, {
      value: portalApi,
      children: /*#__PURE__*/_jsxs(PortalStateContext.Provider, {
        value: data,
        children: [children, Object.values(data).map(obj => obj.portal)]
      })
    })
  });
};
function reducer(state, action) {
  switch (action.type) {
    case 'createPortal':
      return Object.assign({}, state, {
        [action.key]: {
          portal: action.portal
        }
      });
    case 'destroyPortal':
      {
        if (!(action.key in state)) {
          return state;
        }
        return Object.assign({}, Object.keys(state).filter(thisKey => thisKey !== action.key).reduce((prev, curr) => Object.assign({}, prev, {
          [curr]: state[curr]
        }), {}));
      }
    default:
      return state;
  }
}
export const useReactNodeViewPortals = () => useContext(PortalApiContext);
export const useReactNodeViewPortalsCount = () => {
  const state = useContext(PortalStateContext);
  return useMemo(() => Object.keys(state).length, [state]);
};
export default ReactNodeViewPortalsProvider;